import React, {useState} from 'react';
import '../../App.css'
import {
    Box,
    Flex,
    forwardRef,
    HStack,
    IconButton,
    Image,
    Link,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Spacer
} from "@chakra-ui/react";
import {animateScroll, Link as LinkScroll} from 'react-scroll';
import {Link as RouteLink, useMatch} from 'react-router-dom'


import usFlag from '../../images/us_flag.png'
import kaFlag from '../../images/geo_flag.png'
import ruFlag from '../../images/ru_flag.png'
import logo from '../../images/logo_white.png'
import icon from '../../images/logo_icon.png'
import doneImage from '../../images/done_black.png'
import {StickyChildArgs} from "react-sticky";
import LanguageImageComponent from "./LanguageImageComponent";
import {HamburgerIcon} from "@chakra-ui/icons";
import {useTranslation} from "react-i18next";

interface HeaderComponentProps extends StickyChildArgs {

}

const HeaderComponent = forwardRef<HeaderComponentProps, "div">((props, ref) => {


    const [t, i18n] = useTranslation('common');
    const  currentLanguage = (i18n.language === "Georgian" ? 2 : (i18n.language === "Russian" ? 1 : 0));
    const [language, setLanguage] = useState(currentLanguage);


    let enIcon = <LanguageImageComponent src={usFlag} alt="English" name="en"/>;
    let ruIcon = <LanguageImageComponent src={ruFlag} alt="Russian" name="ru"/>;
    let kaIcon = <LanguageImageComponent src={kaFlag} alt="Georgian" name="ka"/>;
    const mSelectorItems = [enIcon, ruIcon, kaIcon]
    const langNameCodes = ['English', 'Russian', 'Georgian']
    const langNames = [t('English'), t('Russian'), t('Georgian')]

    const matchesRoute = useMatch('/')

    return (
        <Box style={props.style} ref={ref} zIndex={1000}>
            <Flex alignItems="center"
                  className="tab-header"
                  backgroundColor={props.isSticky ? "rgba(26, 28, 74, 0.9)" : "transparent"}
                  borderBottom="1px"
                  borderBottomColor="whiteAlpha.200">
                <Link as={RouteLink} to="/" onClick={animateScroll.scrollToTop} margin="10px">
                    <HStack alignItems="center" marginBottom="10px">
                        <Image

                            marginRight="-31px"
                            width="62px"
                            height='62px'
                            src={icon}
                            color="white"
                            alt="Indie app"
                            objectFit="contain"
                        />
                        <Image
                            marginRight="50px"
                            width="110px"
                            height='45px'
                            src={logo}
                            color="white"
                            alt="Indie app"
                            objectFit="contain"
                        />
                    </HStack>
                </Link>
                {matchesRoute && (<Flex className="menu-full header-text">
                    <Link as={LinkScroll} to="actors" smooth={true} offset={-20} margin="10px">
                        <span>{t('For actors')}</span>
                    </Link>
                    <Link as={LinkScroll} to="producers" smooth={true} offset={-20} margin="10px">
                        <span>{t('For producers')}</span>
                    </Link>

                    <Link as={LinkScroll} to="about" smooth={true} offset={-20} margin="10px">
                        <span>{t('About')}</span>
                    </Link>
                </Flex>)}
                <Spacer/>
                <Menu>
                    {({isOpen}) => (
                        <>
                            <MenuButton zIndex="1001"
                                        isActive={isOpen}
                                        as={IconButton}
                                        icon={mSelectorItems[language]}
                                        color="transparent"
                                        outlineColor="transparent"
                                        _selected={{bg: "transparent"}}
                                        _hover={{bg: "transparent"}}
                                        borderColor="transparent"
                                        backgroundColor="transparent"/>
                            <MenuList zIndex="1001">
                                {mSelectorItems.map((val, index) => (
                                    <MenuItem zIndex="1001" onClick={
                                        () => {
                                            if (language !== index) {
                                                console.log(langNames[index])
                                                i18n.changeLanguage(langNameCodes[index])
                                                setLanguage(index)
                                            }

                                        }
                                    }>
                                        {language === index ?
                                            <Image width="26px"
                                                   height="26px"
                                                   padding="5px"
                                                   src={doneImage}
                                                   alt="Selected"
                                                   objectFit="contain"/> :
                                            <Box width="26px" height="26px"/>}

                                        {val}
                                        <span>{langNames[index]}</span>
                                    </MenuItem>
                                ))}
                            </MenuList>
                        </>
                    )}
                </Menu>
                {matchesRoute && <Flex className="menu-short">
                    <Menu>
                        <MenuButton
                            as={IconButton}
                            aria-label="Options"
                            icon={<HamburgerIcon color="white"/>}
                            outlineColor="transparent"
                            backgroundColor="transparent"
                            variant="solid"/>
                        <MenuList>
                            <MenuItem>
                                <Link as={LinkScroll} to="actors" smooth={true} offset={-20} padding="10px">
                                    <span className="footer-text">{t('For actors')}</span>
                                </Link>
                            </MenuItem>
                            <MenuItem>
                                <Link as={LinkScroll} to="producers" smooth={true} offset={-20} padding="10px">
                                    <span className="footer-text">{t('For producers')}</span>
                                </Link>

                            </MenuItem>
                            <MenuItem>
                                <Link as={LinkScroll} to="about" smooth={true} offset={-20} padding="10px">
                                    <span className="footer-text">{t('About')}</span>
                                </Link>
                            </MenuItem>

                        </MenuList>
                    </Menu>
                </Flex>}
            </Flex>
        </Box>
    )
});

export default HeaderComponent